import React from 'react';

const factorsData = [
  {
    id: 'skilled-experts',
    title: 'Skilled Experts',
    desc: 'Our company has experienced and skilled digital marketers who keep themselves updated with the trends. They craft the most effective strategies for you with their knowledge and skills. We provide you with a productive plan that can maximize your online visibility and drive qualified traffic to your platforms that converts into loyal customers.',
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="8" width="36" height="26" rx="4" stroke="#94a3b8" strokeWidth="2.2" />
        <path d="M12 16H22" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" />
        <rect x="12" y="21" width="10" height="8" rx="2" stroke="#c40a0a" strokeWidth="1.8" />
        <path d="M26 21H36" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M26 27H32" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M18 34L14 40H34L30 34" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        {/* Person working at desk/laptop stick illustration */}
        <circle cx="50" cy="25" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M43 23C43 23 46 27 50 27C54 27 57 23 57 23" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M30 55C30 45 40 40 50 40C60 40 70 45 70 55V68H30V55Z" stroke="#ffffff" strokeWidth="3" />
        {/* Laptop & Arms */}
        <path d="M28 58L42 70L58 70L72 58" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M36 70L50 54L64 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 88L25 88L35 78L45 88L65 78L75 88L90 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'transparency',
    title: 'Transparency',
    desc: 'Experts Communication updates you at every step of the process. We give you all the information about your campaign’s performance and provide detailed analytics reports that showcase key metrics, conversion rates, and actionable insights for continuous improvement.',
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="13" stroke="#94a3b8" strokeWidth="2.2" />
        <path d="M30.5 30.5L41 41" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="21" cy="21" r="5" stroke="#c40a0a" strokeWidth="2" />
        <path d="M21 12V14M21 28V30M12 21H14M28 21H30" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" />
        <path d="M15 15L16.5 16.5M25.5 25.5L27 27M15 27L16.5 25.5M25.5 16.5L27 15" stroke="#c40a0a" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        <circle cx="70" cy="62" r="12" stroke="#c40a0a" strokeWidth="3" fill="#000000" />
        <path d="M78 70L88 80" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <path d="M66 62L69 65L75 59" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L30 88L42 78L58 88L72 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'satisfaction-guarantee',
    title: 'Satisfaction Guarantee',
    desc: "Our digital marketing firm's main concern is the satisfaction of clients. We are always here to resolve your queries and answer your questions. We carry out the best processes that bring qualified leads, increased brand awareness, and sustainable business growth to your organization.",
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="24" width="7" height="16" rx="1.5" stroke="#94a3b8" strokeWidth="2.2" />
        <rect x="20" y="16" width="7" height="24" rx="1.5" stroke="#94a3b8" strokeWidth="2.2" />
        <rect x="32" y="8" width="7" height="32" rx="1.5" stroke="#c40a0a" strokeWidth="2.2" fill="rgba(196, 10, 10, 0.08)" />
        <path d="M28 8L35.5 1.5L43 8" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M35.5 2V10" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        <path d="M25 45L15 35M20 55L8 50M24 65L12 65" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M42 70L50 56L58 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L28 88L40 78L56 88L70 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

function DigitalMarketingDifferentiators() {
  return (
    <section className="dig-factors-section">
      <div className="container">
        {/* Centered Heading */}
        <h2 className="dig-factors-title">
          Factors Making Us <span className="text-red">Different From Others</span>
        </h2>

        {/* 3 Black Cards Grid with Hover Corner Icon */}
        <div className="dig-factors-grid">
          {factorsData.map((item) => (
            <div key={item.id} className="dig-factor-card">
              <div className="dig-factor-icon">
                {item.topIcon}
              </div>

              <h3 className="dig-factor-card-title">
                {item.title}
              </h3>

              <p className="dig-factor-card-desc">
                {item.desc}
              </p>

              {/* Bottom Right Hover Stick Icon */}
              <div className="dig-factor-corner-icon">
                {item.cornerIcon}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingDifferentiators;
